import type { FaireProductEntity } from "../../entity_types/product";

export const p_6mrkgs48zd: FaireProductEntity = {
  token: "p_6mrkgs48zd",
  type: "product",
  name: "Tinned Fish Candle - Oakmoss & Amber Soy Wax Summer Gift",
  brandToken: "b_89vkcymc5z",
  brandName: "Tinned Candle",
  imageUrl:
    "https://cdn.faire.com/fastly/fc69fb1c072c50e21440731f5027d52036cac2bd5d410f1d75b2626dcb5833aa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f3c6016513cda3dce6a54ca6e32afd0118a02583fba687aef6f2a9c57afd2b1.jpeg",
    "https://cdn.faire.com/fastly/f251fce146c34cad8fa2a28f6fc04cd442ecef822407513e67b9a2305bd81faa.jpeg",
    "https://cdn.faire.com/fastly/a2164d4a50fcf03ef04d365a96cfd7a471a5cfd27f9a328307f137fea892979e.jpeg",
  ],
  priceDollars: 13,
  description:
    "Earthy, elegant, and a little bit cheeky, this candle blends oakmoss and amber with a soft coral-toned scene of fish packed neatly inside.\n\nPart art piece, part scent experience, it opens just like a tin of sardines — only way cuter. Handmade in Atlanta and now featuring easier-to-open packaging with charming illustrated details.\n\nSoy wax blend. Hand-poured, sealed, and packaged.\n\nIt has the warmth of amber, the mossy depth of oakmoss, and the strange little pleasure of peeling open a tin that looks like it came from a very well-designed pantry shelf.\n\nMade for fall decor shelves, summer-to-fall displays, earthy scent lovers, handmade soy wax pieces, tinned fish collectors, cute match tin pairings, men’s gifts, home decor corners, and shops that like their polished little objects with a sardine-shaped secret.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:07.691Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
